import React, { FunctionComponent } from "react";
import WizardContainer, { WizardProps } from "../../containers/Wizard";
import { TWITTER_PATH, WEBSITE_PATH } from "../../routing/paths";
import FillOrigamiStep from "../FillOrigamiStep";

const FACEBOOK_SPELL_NAME = "facebook";

const FillOrigamiStepProps = {
  previous: WEBSITE_PATH,
  next: TWITTER_PATH,
  question: "What's your <%= target %> page URL",
  target: "Facebook",
  spellName: FACEBOOK_SPELL_NAME,
  placeholder: "username",
  required: false,
  prependValue: "https://facebook.com/",
};

export const FacebookStep: FunctionComponent<WizardProps> = (props: WizardProps) => (
  <FillOrigamiStep wizard={props} {...FillOrigamiStepProps} />
);

export default WizardContainer(FacebookStep);
